import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import Navbar from './components/components/Navbar'
import Hero from './components/components/Hero'
import { About, Contact, Footer, StarsCanvas, Tech, Works } from './components/components'

const App = () => {
  return (
    <BrowserRouter>
      <div className='relative z-0 bg-primary '>
        <div className='bg-secondary  relative z-0' >
          <div>
            <Navbar />
            <Hero />
            <About />
            <Tech />
            <Works />
          </div>
          <StarsCanvas />
        </div>
        <div className='mt-[100px]'>
          <Contact />
        </div>
        <div className='bg-secondary  relative z-0'>
           <Footer/>
           <StarsCanvas/>
        </div>
      </div>
    </BrowserRouter>
  )
}

export default App